import { createSelector } from 'reselect'
import { RootState } from 'duck/store'
import { Organization } from 'scenes/Dashboard/data/organizations/types'

import { getDashboardState } from '../../../duck/selectors'
import { ORGANIZATIONS_MANAGER_STORE_ID } from './types'

export const getOrganizationsManagerState = createSelector(
  getDashboardState,
  (dashboardState) => dashboardState.scenes[ORGANIZATIONS_MANAGER_STORE_ID]
)

export const getSearchParams = createSelector(getOrganizationsManagerState, (organizationManagerState) => ({
  search: organizationManagerState.search,
  limit: organizationManagerState.limit,
  currentPage: organizationManagerState.currentPage,
}))

export const isOrganizationBeingAnalyzed = (state: RootState, organizationId: Organization['id'] | undefined) => {
  if (!organizationId) {
    return false
  }
  return createSelector(
    getOrganizationsManagerState,
    (rootState) =>
      !!rootState.organizationsBeingAnalyzed.find((analyzedOrganizationId) => analyzedOrganizationId === organizationId)
  )(state)
}

// Popup
export const getOrganizationManagerPopupState = createSelector(
  getOrganizationsManagerState,
  (organizationsState) => organizationsState.deletePopup
)
